import { Component, ElementRef, Renderer, Input, Output, Optional, EventEmitter, ViewEncapsulation } from '@angular/core';

/**
 * 
 * # Angular2-Image-OR-Content-Slider
A simple component which accepts an array of image or content for sliding.

Basic Usage
```typescript
    @Component({
        selector: 'ImageShow',
        template: `
        <contentSlider [slides]="images"></contentSlider>
        `
    })
    export class ImageShowComponent implements  AfterViewInit{
       images:Array<any> = [{"sType":"img","imgSrc":"..."},{"sType":"div","content":"...Hello It's slidable content"}];
      constructor(){
      }
    }
```

For having a full understanding of source-code please see this article

http://www.ravinderpayal.com/Simple-and-Light-Weight-Image-or-Content-Slider-for-Angular2/
 * 
 * 
 */


@Component({
    selector: 'content-slider',
    templateUrl: 'content-slider.component.html',
    styleUrls: ["content-slider.component.less"],
    encapsulation: ViewEncapsulation.None
})
export class ContentSliderComponent {
    /**
     * Play Interval
     */
    @Input('playInterval') 
    interval: any = 2000;
    slides: any;

    @Input('showButtons')
    showButtons = true;

    @Input("slides") set _slides(s) {
        this.slides = s;
        //console.log(this.slides);
        this.number = this.slides.length;
        if (this.slides.length)
            this.slides[0]["classes"] = ["active"];
    }

    @Input('autoPlay') set _autoPlay(b: boolean) {
        this.autoPlay = b
        if (b) {
            this.auto(this.interval);
        }
    }
    currentElement: number = 0;
    autoPlay = false;
    number: number = 0;
    //lis:number = 0;
    intervalTime: number = 1000;//in ms(mili seconds)
    private delayHideSetTimeOutControl: any;
    constructor() {
        //this.slideShow=document.getElementById("slideShow");

        //this.lis = this.slides.length;

        //this.number=this.lis.length;
    }
    backWard(active?: number) {
        if (this.autoPlay){
            clearInterval(this.interval);
        }
        this.currentElement--;

        if (this.currentElement < 0) {
            this.currentElement = this.number - 1;
        }
        this.removeClasses();
        let prev = active!=undefined ? active : (this.currentElement == this.number - 1 ? 0 : this.currentElement + 1);
        
        //this.lis[prev].classList.add("animateForward");
        this.slides[prev].classes = ["animateForward"];
        this.show(this.slides[prev]);
        this.show(this.slides[this.currentElement]);

        clearTimeout(this.delayHideSetTimeOutControl);

        this.delayHideSetTimeOutControl = this.delayHide(this.slides[prev], 500);
        //this.lis[this.currentElement].classList.add("active");
        this.slides[this.currentElement].classes = ["active", "backward"];
        //this.lis[this.currentElement].classList.add("backward");
        if (this.autoPlay) this.auto(this.intervalTime);
    }

    removeClasses() {
        for (let i = 0; i < this.number; i++) {
            this.slides[i].classes = {}
        }
    }
    forWard(active?: number) {
        //console.log("forward called")
        if (this.autoPlay) clearInterval(this.interval);
        this._forWard(active);
        if (this.autoPlay) this.auto(this.intervalTime);
    }
    private _forWard(active?: number) {
        this.currentElement = 1 + this.currentElement;
        //this.lis=this.slideShow.childNodes;
        if (this.currentElement >= this.number) {
            this.currentElement = 0;
        }
        this.removeClasses();
        let prev = active!=undefined ? active : (this.currentElement == 0 ? this.number - 1 : this.currentElement - 1);
        //this.lis[prev].classList.add("animateBack");
        //console.log(this.slides[prev]);
        this.slides[prev]["classes"] = ["animateBack"];

        this.show(this.slides[prev]);

        clearTimeout(this.delayHideSetTimeOutControl);
        this.delayHideSetTimeOutControl = this.delayHide(this.slides[prev], 500);
        //this.lis[this.currentElement].classList.add("active");
        //this.lis[this.currentElement].classList.add("forward");
        this.slides[this.currentElement].classes = ["active", "forward"];
        this.show(this.slides[this.currentElement]);
    }
    auto(ms) {
        this.autoPlay = true;
        this.intervalTime = ms;
        this.interval = setInterval(this._forWard.bind(this), ms);
    }
    delayHide(el, ms, show = true) {
        return setTimeout(() => el.hidden = show, ms);
    }
    show(el) {
        el.hidden = false;
    }
    goTo(index: number): void {
        let active = this.currentElement;
        let isBackward = index < active;
        this.currentElement = isBackward ? index+1 : index-1;
        if (isBackward) {
            this.backWard(active);
        } else this.forWard(active);
        
    }
}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/carousel/content-slider.component.ts